/**
 * The complete BJCP 2021 beer style set — categories 1–34, plus the X series.
 *
 * Split into files purely for editing sanity; the exported collection is in
 * guideline order, which is the order the style picker renders. The
 * provisional styles come last, after the numbered categories, because that is
 * where they sit in the guidelines and where a brewer scanning the list
 * expects the unsettled ones to be.
 */

import type { Style } from '../../schema/style';
import { styleCategories01To12 } from './categories-01-12';
import { styleCategories13To22 } from './categories-13-22';
import { styleCategories23To34 } from './categories-23-34';
import { provisionalStyles } from './provisional';

export { styleCategories01To12 } from './categories-01-12';
export { styleCategories13To22 } from './categories-13-22';
export { styleCategories23To34 } from './categories-23-34';
export { provisionalStyles } from './provisional';

/** Every style in the catalog, in BJCP category order. */
export const styles: readonly Style[] = [
  ...styleCategories01To12,
  ...styleCategories13To22,
  ...styleCategories23To34,
  ...provisionalStyles,
];
